/**
 * StatusBadge Component
 * 
 * A reusable badge component for displaying status with color variants
 * 
 * @param {string} status - The status text to display
 * @param {string} variant - The color variant (primary, success, warning, danger, info, secondary)
 * @param {string} className - Additional CSS classes
 */

import React from 'react';
import './StatusBadge.css';

const StatusBadge = ({ status, variant = 'primary', className = '' }) => {
    return (
        <span className={`status-badge status-badge-${variant} ${className}`}>
            {status}
        </span>
    );
};

export default StatusBadge;
